export const formatPickupTimeLabel = (timeOfPickup) => {
    if (!timeOfPickup)
        return '';
    const value = String(timeOfPickup).trim();
    const match = /T(\d{2}):(\d{2})/.exec(value) ?? /^(\d{1,2}):(\d{2})/.exec(value);
    if (!match)
        return '';
    return `${match[1].padStart(2, '0')}:${match[2]}`;
};
export const mapPickupLocationToOption = (location) => ({
    label: location.name,
    value: location.id,
    hasAccommodation: location.isAccommodationAvailable,
    description: location.description ?? undefined,
    timeOfPickup: location.timeOfPickup,
    companies: location.companies ?? [],
    isClosed: location.isClosed
});
export const mapRawPickupLocationToOption = (row) => {
    const id = String(row.id ?? row.Id ?? '').trim();
    const name = String(row.name ?? row.Name ?? '').trim();
    if (!id || !name)
        return null;
    const rawCompanies = Array.isArray(row.companies)
        ? row.companies
        : Array.isArray(row.Companies)
            ? row.Companies
            : [];
    const companies = rawCompanies
        .map((company) => {
        const entry = company;
        return {
            id: String(entry.id ?? entry.Id ?? '').trim(),
            name: String(entry.name ?? entry.Name ?? '').trim()
        };
    })
        .filter((company) => company.id.length > 0 && company.name.length > 0);
    const description = String(row.description ?? row.Description ?? '').trim();
    const timeOfPickup = (row.timeOfPickup ?? row.TimeOfPickup ?? null);
    return {
        label: name,
        value: id,
        hasAccommodation: !!(row.isAccommodationAvailable ?? row.IsAccommodationAvailable),
        description: description || undefined,
        timeOfPickup,
        companies,
        isClosed: !!(row.isClosed ?? row.IsClosed)
    };
};
export const getPickupLocationInputLabel = (option) => {
    if (typeof option === 'string')
        return option;
    if (!option?.label)
        return '';
    const time = formatPickupTimeLabel(option.timeOfPickup);
    return time ? `${option.label} (${time})` : option.label;
};
export const buildSavedPickupLocationOption = (person) => {
    const value = String(person.transportLocation ?? '').trim();
    if (!value)
        return null;
    const label = String(person.pickupLocationName ?? '').trim() || value;
    return {
        label,
        value,
        hasAccommodation: !!person.isPickupAccommodationAvailable
    };
};
export const ensureSelectedPickupLocationInOptions = (options, selectedValue, savedOption) => {
    const selectedId = String(selectedValue ?? '').trim();
    if (!selectedId)
        return options;
    if (options.some((option) => option.value === selectedId))
        return options;
    const fallback = savedOption ?? { label: selectedId, value: selectedId };
    return [fallback, ...options];
};
export const filterPickupLocationOptions = (options, inputValue) => {
    const query = inputValue.toLowerCase().trim();
    if (!query)
        return options;
    return options.filter((option) => {
        if (option.label.toLowerCase().includes(query))
            return true;
        if ((option.description ?? '').toLowerCase().includes(query))
            return true;
        if (formatPickupTimeLabel(option.timeOfPickup).includes(query))
            return true;
        return (option.companies ?? []).some((company) => company.name.toLowerCase().includes(query));
    });
};
